import React, { Component } from 'react';
import './Pay.css';
import data from '../../data/Pay.js';

import Layout from '../../components/Layout/Layout';
import Icon from '../../components/Icon/Icon';
import Intro from '../../components/Intro/Intro';

import FastFacts from './FastFacts/FastFacts';
import PayFAQ from './PayFAQ/PayFAQ';
import Payroll from './Payroll/Payroll';
import Timesheet from './Timesheet/Timesheet';

class Pay extends Component {
	render() {
		return (
			<Layout colors={ data.colors }>
				<div className="Pay">
					<Intro>
						<Icon icon="pay.intro" title="The Almighty Dollar" />
						<div className="intro-title">
							<h1>The <span>Almighty</span> Dollar</h1>
							<p>
								Looking to get paid but have a million questions? Have a life change and need a new tax form? Or maybe you’re ready to start saving for retirement? Look no further!
							</p>
							<p>
								The Almighty Dollar section covers time and money and has links to the resources you need to get started!
							</p>
						</div>
					</Intro>
					
					<FastFacts facts={ data.fastFacts } />
					<Payroll docs={ data.docs } />
					<Timesheet />
					<PayFAQ faq={ data.faq } />
				</div>
			</Layout>
		);
	}
};

export default Pay;



// WEBPACK FOOTER //
// ./src/pages/Pay/Pay.js